import React from 'react';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import { dark_mode } from '../../Utility/constants';


const ModalComponent = ({ modalIsOpen, content, width, height }) => {
  const mode = useSelector(state => state.mode)

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: window.innerWidth < 768 ? 'translate(-50%, -50%)' : 'translate(-50%, -50%)',
      backgroundColor: mode === dark_mode ? '#EE31AF' : '#fff',
      border: "0px solid #ECECEC",
      boxShadow: "padding-box 10px 10px 25px #AEAEC040, 10px 5px 30px #000",
      width: window.innerWidth < 768 ? '80%' : `${width}`,
      height: height ? height : "auto",
      borderRadius: '15px',
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 9,
    }
  };
  return (
    <Modal
      isOpen={modalIsOpen}
      // onAfterOpen={afterOpenModal}
      // onRequestClose={closeModal}
      style={customStyles}
      clic
      contentLabel="Example Modal"
    >
      {content}
    </Modal>
  )
}


export default ModalComponent